import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.POLYGONS_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.POLYGONS_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const polygonList = (params) => {
  return async (dispatch) => {
    dispatch({ type: CONST.POLYGONS_LIST_REQUEST });

    axios
      .get('/polygon', { params })
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((response) => {
        onFailed(dispatch, response.response.data);
      });
  };
};
